export default function NotifyHeader({ onClose, filters, filter, setFilter }) {
  return (
    <div className="flex items-center justify-between px-2 pt-4 border-b border-aw-bluedark-50">
      
        <h2 className="text-sm font-bold text-white">Actividad Reciente</h2>
        {/* <div className="flex items-center gap-2">
          <span className="text-sm text-gray-300">Ordenar por:</span>
          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="bg-aw-bluedark-95 text-white text-sm rounded-2xl px-2 py-1 border border-aw-bluegray focus:outline-none"
          >
            {filters.map((f) => (
              <option key={f.value} value={f.value}>
                {f.label}
              </option>
            ))}
          </select>
        </div> */}
    
      <button
        onClick={onClose}
        className="text-white text-xl font-bold hover:text-aw-green"
      >
        &times;
      </button>
    </div>
  );
}
